import { KitCampaign } from 'models/KitCampaign';
import { TiendaPerfectaDistributor } from 'models/TiendaPerfecta';

import { UseRoleModalsReturn } from '../hooks/useRoleModals';
import DetailRoleModal from './DetailRoleModal';
import NewMenuDetailModal from './NewMenuDetailModal';
import NewRoleModal from './NewRoleModal';

interface RoleModalsProps {
  modals: UseRoleModalsReturn;
  campaigns: KitCampaign[];
  kitIntegrationEnabled: boolean;
  tiendaPerfectaIntegrationEnabled: boolean;
  tiendaPerfectaDistributors: TiendaPerfectaDistributor[];
  tiendaPerfectaDistributorsLoading: boolean;
}

function RoleModals({
  modals,
  campaigns,
  kitIntegrationEnabled,
  tiendaPerfectaIntegrationEnabled,
  tiendaPerfectaDistributors,
  tiendaPerfectaDistributorsLoading,
}: RoleModalsProps) {
  const {
    isNewRoleModalOpen,
    isDetailModalOpen,
    isMenuDetailModalOpen,
    selectedRow,
    closeNewRoleModal,
    closeDetailModal,
    closeMenuDetailModal,
    createNewRole,
    editRole,
  } = modals;

  return (
    <>
      <NewRoleModal
        isOpen={isNewRoleModalOpen}
        handleModalCancel={closeNewRoleModal}
        submit={createNewRole}
        campaigns={campaigns}
        kitIntegrationEnabled={kitIntegrationEnabled}
        tiendaPerfectaIntegrationEnabled={tiendaPerfectaIntegrationEnabled}
        tiendaPerfectaDistributors={tiendaPerfectaDistributors}
        tiendaPerfectaDistributorsLoading={tiendaPerfectaDistributorsLoading}
      />
      {selectedRow && (
        <DetailRoleModal
          isOpen={isDetailModalOpen}
          id={selectedRow.id}
          handleModalCancel={closeDetailModal}
          submit={editRole}
          campaigns={campaigns}
          kitIntegrationEnabled={kitIntegrationEnabled}
          currentCampaignIds={selectedRow.campaigns?.map((c) => c.id) ?? []}
          tiendaPerfectaIntegrationEnabled={tiendaPerfectaIntegrationEnabled}
          tiendaPerfectaDistributors={tiendaPerfectaDistributors}
          tiendaPerfectaDistributorsLoading={tiendaPerfectaDistributorsLoading}
        />
      )}
      {selectedRow && (
        <NewMenuDetailModal
          role={selectedRow}
          isOpen={isMenuDetailModalOpen}
          handleModalCancel={closeMenuDetailModal}
        />
      )}
    </>
  );
}

export default RoleModals;
